import { render, staticRenderFns } from "./ListPackage.vue?vue&type=template&id=dfb204a4&scoped=true&"
import script from "./ListPackage.vue?vue&type=script&lang=ts&"
export * from "./ListPackage.vue?vue&type=script&lang=ts&"
import style0 from "./ListPackage.vue?vue&type=style&index=0&id=dfb204a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb204a4",
  null
  
)

export default component.exports